import { TextFieldWidget } from '@tableau/widgets';
import { FormikContextType } from 'formik';
import * as React from 'react';

import { Messages } from '../../../../../codegen/Localize';
import { tableCell, wideField } from '../../../styles/site-name-and-id/SiteNameAndIdStyles';
import { calculateUrlNameFromSiteName } from './SiteNameAndIdBusinessLogic';
import { SiteNameAndIdSectionProps } from './SiteNameAndIdSection';

export function useSiteNameChangeHandler(formik: FormikContextType<SiteNameAndIdSectionProps>, shouldCopySiteNameToUrl: boolean, isUrlNameModified: boolean) {
  return React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      formik.setFieldTouched('settings.name', true, false);
      formik.setFieldValue('settings.name', e.target.value, !shouldCopySiteNameToUrl || isUrlNameModified);
      if (shouldCopySiteNameToUrl && !isUrlNameModified) {
        formik.setFieldTouched('settings.urlName', true, false);
        formik.setFieldValue('settings.urlName', calculateUrlNameFromSiteName(e.target.value), true);
      }
    },
    // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      isUrlNameModified,
      shouldCopySiteNameToUrl,
      formik.setFieldValue,
      formik.setFieldTouched,
      formik.handleChange,
    ]);
}

export type SiteNameRowProps = {
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

export const SiteNameRow: React.FunctionComponent<SiteNameRowProps> = props =>
  <tr>
    <td className={tableCell}><label>{Messages.siteName_colon()}</label></td>
    <td>
      <TextFieldWidget testId={'site-name-input'}
                       className={wideField}
                       placeholder={Messages.siteNamePlaceholderMsg()}
                       value={props.name}
                       maxLength={100}
                       required={true}
                       label={null}
                       name={'settings.name'}
                       onChange={props.onChange}
      />
    </td>
  </tr>;
